/**
 * DEV4-5013 — o bloqueio legado do disparador, isolado para ser testável.
 *
 * Empresa que **não** está na nova interface mantém exatamente o comportamento
 * de hoje: operador sem a flag de campanha é devolvido ao chat. Empresa na nova
 * interface não é barrada aqui — quem decide é o `validateToken` do
 * polichat-web-app, e o disparador exibe a mensagem de "sem acesso".
 *
 * Acrescentar `!foundation` a uma condição de bloqueio só pode deixar de
 * bloquear empresa foundation; para as demais é impossível mudar o resultado.
 *
 * @param {{ foundation?: boolean, canUseMarketing?: boolean, superRole?: string }} params
 * @returns {boolean}
 */
export function shouldBlockLegacyAgent({
  foundation,
  canUseMarketing,
  superRole,
}) {
  return !foundation && !canUseMarketing && superRole === 'agent';
}
